var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 19,
    viewBox: "0 0 3 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(1 0 0 -1 1.5 1.5)",
    fill: "#212429"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(1 0 0 -1 1.5 9.5)",
    fill: "#212429"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(1 0 0 -1 1.5 17.5)",
    fill: "#212429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreSvg);
export default __webpack_public_path__ + "static/media/more-svg.40fd6252fd84a7c45d99347f73eb980d.svg";
export { ForwardRef as ReactComponent };